var redefine = require('./_redefine');
module.exports = function (target, src, safe) {
  for (var key in src) redefine(target, key, src[key], safe);
  return target;
};



// WEBPACK FOOTER //
// ./techpad-upgrade/~/core-js/modules/_redefine-all.js